import classnames from "classnames";
import React from "react";

export const Note = ({ className, label }) => {
  return (
    <div
      className={classnames(
        "tw-text-[#7e77a2] tw-tracking-[0.22px] tw-decoration-solid tw-decoration-auto tw-underline-offset-auto tw-underline-from-font",
        className
      )}
    >
      {label}
    </div>
  );
};
